import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTenantUomNamesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantUomNamesQuery = { __typename?: 'Query', tenantUomNames: Array<string> };


export const GetTenantUomNamesDocument = new TypedDocumentString(`
    query GetTenantUomNames {
  tenantUomNames
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantUomNames: build.query<GetTenantUomNamesQuery, GetTenantUomNamesQueryVariables | void>({
      query: (variables) => ({ document: GetTenantUomNamesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantUomNamesQuery, useLazyGetTenantUomNamesQuery } = injectedRtkApi;
